import { configureStore } from '@reduxjs/toolkit';
import logger from 'redux-logger';
import thunk from 'redux-thunk';
import rootReducer from '../rootReducer';

const isProd = process.env.NODE_ENV === 'production';
const middleware = isProd ? [thunk] : [thunk, logger];

const store = configureStore({
  reducer: rootReducer,
  devTools: !isProd,
  middleware,
});

export default store;
